import styled from 'styled-components'
import { theme, Box as BoxComp } from '@/client/components'
const { borders, color, space, breakpoint } = theme

export const Contact = styled.div`
  margin-top: ${space.xl4};
  text-align: center;

  @media (min-width: ${breakpoint.lg}) {
    margin-top: 0;
  }
`

export const ContactCard = styled(BoxComp)`
  display: flex;
  flex-direction: column;
  max-width: 17rem;
  margin: 0 auto ${space.xl2};
  border-radius: ${borders.radius.md};
  background-color: ${color.grayscale.white};
  box-shadow: 0px 0px 30px #1021331a;
  overflow: hidden;

  @media (min-width: ${breakpoint.md}) {
    flex-direction: row;
    max-width: 100%;
  }

  @media (min-width: ${breakpoint.lg}) {
    flex-direction: column;
    max-width: 17rem;
  }
`

export const CardImage = styled.div`
  width: 100%;
  overflow: hidden;

  @media (min-width: ${breakpoint.md}) {
    max-width: 12rem;
  }

  @media (min-width: ${breakpoint.lg}) {
    max-width: 17rem;
  }
`

export const ContactCardInfos = styled.div`
  padding-top: ${space.lg};
  padding-bottom: ${space.md};
  padding-left: ${space.sm};
  padding-right: ${space.sm};
  text-align: center;

  @media (min-width: ${breakpoint.md}) {
    padding-left: ${space.lg};
    padding-right: ${space.lg};
    text-align: left;
  }

  @media (min-width: ${breakpoint.lg}) {
    padding-left: ${space.sm};
    padding-right: ${space.sm};
    text-align: center;
  }
`
